import './Ajuda.css';
import AjudaItem from '../AjudaItem';

const Ajuda = () => {

    return (
        <aside className="ajuda">
            <h3 className="ajuda__titulo">
                <i className="material-icons">help</i>Dúvidas Frequentes
            </h3>
            <ul className="ajuda__lista">

                <AjudaItem 
                    icone="add" 
                    titulo="O que encontro no site Viver Espírita?" 
                    texto="Nosso portal é dedicado ao estudo e divulgação da Doutrina Espírita e dos ensinamentos morais do Evangelho de Jesus. Aqui você encontra artigos doutrinários, estudos das Obras Básicas, um fórum de estudos e debates para perguntas e esclarecimentos, e informações para participar de nossas reuniões online."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Onde encontro os artigos e publicações?" 
                    texto="Você pode acessar os artigos diretamente pelo menu principal em 'Artigos' ou através dos destaques e do carrossel na página inicial. Todo o acervo de artigos do site é aberto e gratuito para leitura."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Como participo das reuniões de estudos online?" 
                    texto="Nossos estudos acontecem semanalmente aos domingos, às 20h, de forma online e gratuita via Google Meet. O link de acesso direto e os detalhes estão disponíveis na seção 'Estudos online' na página inicial."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="É necessário cadastrar-se para navegar no site?" 
                    texto="Não. A leitura dos artigos, as informações doutrinárias e o acesso aos encontros online são abertos a todos os visitantes. O cadastro é necessário apenas para interagir no Fórum de Estudos (criar tópicos e responder mensagens)."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Como faço meu cadastro?" 
                    texto="No menu superior, clique na opção 'Cadastre-se'. Preencha seu nome, um e-mail válido e sua senha. Após enviar o formulário, você receberá um e-mail para ativar sua conta e liberar o acesso."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Por que é obrigatório informar um e-mail válido?" 
                    texto="O e-mail é a sua identificação única no site. Ele é indispensável para enviar o link de ativação da sua conta, permitir a recuperação de senha caso a esqueça e enviar novidades do portal se você optar por recebê-las."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Onde posso postar minhas dúvidas e perguntas?" 
                    texto="No nosso Fórum de estudos e debates, acessível pelo menu superior. Estando conectado à sua conta, você pode iniciar novos tópicos com dúvidas sobre as obras básicas e temas da Doutrina, além de responder e participar das discussões em tópicos de outros participantes."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Como funciona a moderação e onde vejo as respostas no fórum?" 
                    texto="Para manter o fórum de estudos e debates organizado e focado nos ensinamentos doutrinários, as novas mensagens passam por uma moderação prévia. Uma vez aprovadas, ficam visíveis no fórum para toda a comunidade interagir. Você pode acompanhar todas as suas participações no seu Perfil em 'Minhas Mensagens do Fórum'."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Quais dados são armazenados e como são protegidos?" 
                    texto="Armazenamos apenas os dados essenciais para identificação e login: seu nome, e-mail, telefone e senha (criptografada). Nosso site utiliza conexão segura via certificado SSL e seus dados não são compartilhados com terceiros."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Como ativar ou desativar o recebimento de e-mails informativos?" 
                    texto="Você pode escolher receber informativos no momento do cadastro. Caso queira alterar essa preferência depois, faça login, clique em 'Perfil' no menu superior, acesse 'Meus Dados' e marque ou desmarque a opção de receber e-mails."
                />

                <AjudaItem 
                    icone="add" 
                    titulo="Onde encontro a Política de Privacidade do site?" 
                    texto="Nossa Política de Privacidade está disponível a qualquer momento através do link 'Política de Privacidade' localizado no rodapé da home do site."
                />

            </ul>
        </aside>
    );
};

export default Ajuda;